import lloydLogo from '../assets/Lloyd.jpeg';
import tataTanishqLogo from '../assets/Tata Tanishq.jpeg';
import toliaLogo from '../assets/Tolia Group Of Companies.jpeg';
import trishulaLogo from '../assets/Trishula Robotics solution.jpeg';

export const clients = [
  { id: 1, name: 'Lloyd', logo: lloydLogo },
  { id: 2, name: 'Tata Tanishq', logo: tataTanishqLogo },
  { id: 3, name: 'Tolia Group Of Companies', logo: toliaLogo },
  { id: 4, name: 'Trishula Robotics Solution', logo: trishulaLogo },
];
